import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent } from './tips-outline.svg';

export const TipsOutline: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <ReactComponent />
  </SvgIcon>
);
